import { HttpClient, HttpEvent, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import {
    IImageUploadSuccess,
    IImageUploadSuccessResponse,
} from '@app/@shared/Models/form-data.model';
import {
    ISelectedVariants,
    ISetThemeData,
    ISetThemeVariant,
    ISetVariantSizeChart,
    IVariantGridData,
    IVariantModelData,
} from '@app/add-product/models/variant-grid-data-model';
import {
    AbstractControl,
    FormControl,
    FormGroup,
    ValidationErrors,
    ValidatorFn,
    Validators,
} from '@angular/forms';
import { AddProductService } from '@app/add-product/add-product.service';
import { ColorObj } from '@app/add-product/models/multiselect-model';
import { SellerPortalEventBrokerService } from '@app/@core/services/event-broker/seller-portal-event-broker.service';
import { SetSelectedTabEventBroker } from './event-broker/set-selected-panel-broker';
import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogRef,
} from '@angular/material/dialog';
import { VariantModalComponent } from '@app/@shared/components/variant-modal/variant-modal.component';
import { DeleteSetVariantsDialogComponent } from '../delete-set-variants/delete-set-variants-dialog.component';
import { DeleteSetVariantNewDialogComponent } from '../delete-set-variants/delete-set-variant-new-dialog/delete-set-variant-new-dialog.component';

@Injectable({
    providedIn: 'root',
})
export class SetsService {
    public finalPayload: any = {};
    public variantAttributesMaster: any;
    public productAttributesMaster: any;
    public schemaPropertyAttribute: any;
    public colorAtt: any = [];
    public setItems: any = [];
    public editFlowState: boolean = false;
    public variantItemIndex: any = 1;
    public productDetailsSaved: string = undefined;
    public variationThemeId: any = undefined;
    public setThemeId: any = undefined;
    public relativeCategoryPath: string;
    public firstInitCall: boolean = undefined;
    private messageSource = new BehaviorSubject<any>(null);
    private colorCode: ColorObj[];
    private footwearSize = [];
    variantInfoAttr = this.messageSource.asObservable();
    public relativeCat: {
        productType: any;
        category: string;
        subCategory: string;
        type: string;
        subType: string;
    };
    primaryColorAdded$ = new Subject();
    private sizeTypeChangeSubject = new Subject<boolean>();
    sizeTypeChange$ = this.sizeTypeChangeSubject.asObservable();
    public selectedVaraintsList: Array<ISelectedVariants> = [];
    public selectedVaraintsListSizeChart: ISetVariantSizeChart;
    VARIANT_MANDATORY_FIELDS: string[] = [
        'SET_ITEMS',
        'SET_NAME',
        'SKU_ID',
        'MOQ',
        'MRP',
        'SELLING_PRICE',
        'EAN_NUMBER',
        'STOCK',
    ];
    NON_PROPERTIES: string[] = [
        'SIZE_CHART_DOCUMENT_ID',
        'IS_DEFAULT',
        'IS_ACTIVE',
        'IS_DELETED',
        'ID',
        '_ID',
        'CATEGORY',
        'SCHEMA_NAME',
        'SUB_CATEGORY',
        'TYPE',
        'SUB_TYPE',
        'SELLER_ID',
        'ATTRIBUTES',
        'VARIANT_ATTRIBUTES',
        'VARIANTS',
        'IMAGES',
        'PRIMARY_IMAGE',
        'STATE, VARIATION_THEME_ID',
        'PRIMARY_COLOR',
        'SIZE_TYPE',
        'PRODUCT_TYPE',
        'ADDITIONAL_PROPERTIES',
        'SET_THEME_ID',
        'FOOTWEAR_SIZE_TYPE',
    ];

    variantSetDataFormList;
    variantSetDataFormRequiredList;
    variantThemeData: ISetThemeData;
    addittionalFieldsObj: any;
    schemaProperties: any;
    themes: any = [];
    footwearSize$ = new BehaviorSubject(null);
    productAttributesSchema: any;
    additionalPropertiesDetails: any;
    additionalDetails: any;
    FootwearvariantThemeData: any;
    private currentSizeType = '';
    themeKnot: any;
    numericId: any;
    submitbtnDisable$ = new BehaviorSubject(false);
    dataCleared$ = new BehaviorSubject(false);
    productDetailsValid$ = new BehaviorSubject(true);
    additionalDetailsValid$ = new BehaviorSubject(true);
    variantDetailsValid$ = new BehaviorSubject(false);
    variantSaveSet$ = new BehaviorSubject(true);
    variantSetMetaDataValid$ = new BehaviorSubject(true);
    customSetName$ = new BehaviorSubject<any>(null);
    isEditColor$ = new BehaviorSubject(false);
    enableSetAttributeForm$ = new BehaviorSubject<boolean>(false);
    deleteSetColor$ = new BehaviorSubject<boolean>(false);
    savedSetData$ = new BehaviorSubject<any>(null);
    setDataChanged$ = new BehaviorSubject(false);
    setColorDeleted$ = new BehaviorSubject<boolean>(false);

    private dialogRef: MatDialogRef<DeleteSetVariantNewDialogComponent>;
    categoryId: any;
    brandDetail$ = new BehaviorSubject([]);
    currentSize$ = new BehaviorSubject(null);
    sizeTypeValue: any;
    isFootwearCat = false;
    apparelSize = [];
    sizeTheme = "size"
    availableSizes = []
    attributeMapper = {}

    constructor(
        private httpClient: HttpClient,
        private addProductService: AddProductService,
        private eventBroker: SellerPortalEventBrokerService,
        private dialog: MatDialog
    ) {}

    getAllCategories() {
        return this.httpClient.get(
            environment.with_auth_url + '/seller/api/v1/category'
        );
    }

    getProductDetails(productId) {
        return this.httpClient.get(
            environment.with_auth_url +
                '/seller/api/v1/product/review/product-detail?productId=' +
                productId
        );
    }
    // for footwear category
    getProductDetailsForFootwear(productId) {
        return this.httpClient.get(
            environment.with_auth_url +
                '/seller/api/v1/product/review/migrated/product-detail?noStockAttribute=true&productId=' +
                productId
        );
    }
    setCategorySelection(relativeCategories) {
        this.relativeCat = relativeCategories;
    }

    getCategorySelection() {
        return this.relativeCat ? this.relativeCat : null;
    }

    setRelativeCategoryPath(relativeCategoryPath) {
        this.relativeCategoryPath = relativeCategoryPath;
    }

    getRelativeCategoryPath() {
        return this.relativeCategoryPath ? this.relativeCategoryPath : null;
    }

    intializeFinalPayload() {
        this.finalPayload = {} as any;
    }

    setInitialPayloadToFinalPayload(payloadObj) {
        this.finalPayload = { ...payloadObj };
    }

    updateFinalPayloadForEdit(payloadObj) {
        this.finalPayload = { ...this.finalPayload, ...payloadObj };
        console.log('final Payload on Edit', this.finalPayload);
    }

    getProductDetailsFormStatus() {
        return this.productDetailsSaved;
    }

    setProductDetailsFormStatus() {
        this.productDetailsSaved = undefined;
    }

    getSchemaName(subCatId = '') {
        if (this.schemaProperties?.schemaName?.enum) {
            return this.schemaProperties.schemaName.enum[0];
        }
        return 'APPARELS_SET';
    }

    fetchVariationThemeId(
        categoryId = '16abecae-91a8-4096-821f-e77d3703a020',
        productType = 'SET'
    ) {
        let params = new HttpParams();
        params = params.append('productType', productType);
        const url =
            environment.with_auth_url +
            '/productcategory/api/v1/variationthemes/category/' +
            categoryId;
        return this.httpClient.get(url, { params });
    }

    publishSet(finalPayload, isSetFlow) {
        if (isSetFlow) {
            return this.httpClient.put(
                environment.with_auth_url + '/product-catalog/api/v3/products',
                finalPayload
            );
        } else {
            return this.httpClient.post(
                environment.with_auth_url + '/product-catalog/api/v3/products',
                finalPayload
            );
        }
    }

    getVariantAttributes() {
        return this.variantAttributesMaster;
    }

    getProductAttributesMaster() {
        return this.productAttributesMaster;
    }
    setProductAttributes(productAttributesList, variantAttributesList) {
        this.productAttributesMaster = productAttributesList;
        this.variantAttributesMaster = variantAttributesList;
    }

    saveProductAttributes(productInfo, productAttrInfo) {
        const updatedAttribute = {
            ...this.finalPayload.attributes,
            ...productAttrInfo,
        };
        this.productDetailsSaved = 'Product Details Saved';
        this.finalPayload = { ...this.finalPayload, ...productInfo };
        this.finalPayload = {
            ...this.finalPayload,
            attributes: updatedAttribute,
        };
        this.setFootwearSize(this.finalPayload.attributes.sizeType);
        let extraKeys = [
            'l1NumericID',
            'l2NumericID',
            'l3NumericID',
            'l4NumericID',
        ];
        extraKeys.forEach((el) => {
            if (this.finalPayload[el]) {
                delete this.finalPayload[el];
            }
        });
        if (this.addProductService.getCategoryName() == 'FOOTWEAR' || this.addProductService.isApparelCategory) {

                this.finalPayload.variationThemeKnot =
                    this.getVariationThemeKnot() || "setName";
            const leafNodeId =
            this.addProductService.fetchLeafCategoryNumericID() || this.addProductService.getleafNumericId() || this.getNumericId() || localStorage.getItem('leafNodeId');;
            this.finalPayload.leafNodeId = leafNodeId;
        }
    }
    getProductAttributes() {
        return {
            productDetailsSaved: this.productDetailsSaved,
            finalPayload: this.finalPayload,
        };
    }

    saveProductAdditionalAttributes(productAttributeAdditionalData) {
        this.finalPayload['attributes'] = { ...productAttributeAdditionalData };
    }

    updateSetItemPayload(payload, index?) {
        if (index != undefined) {
            this.setItems[index] = payload;
        } else {
            this.setItems.push(payload);
        }
    }

    getSetItemPayload() {
        return this.setItems;
    }

    deleteSetItemBasedOnColor(index) {
        this.setItems.splice(index, 1);
    }

    deleteSet() {
        this.setItems?.splice(0);
    }

    clearSetItems() {
        this.setItems = [];
    }

    updateSetItemOnEdit(setItemList) {
        this.setItems = setItemList;
    }

    setIsEditFlowFromAttributeScreen(isEditFlow, variantItemIndex) {
        this.editFlowState = isEditFlow;
        this.variantItemIndex = variantItemIndex;
    }

    isSetEdit() {
        return {
            isEditFlow: this.editFlowState,
            variantItemIndex: this.variantItemIndex,
        };
    }

    updateFinalPayloadFromSetItems(payload, index?) {
        if (
            !this.finalPayload.hasOwnProperty('variants') &&
            index === undefined
        ) {
            this.finalPayload['variants'] = [];
            this.finalPayload.variants.push(payload);
        } else if (
            this.finalPayload.hasOwnProperty('variants') &&
            index != undefined
        ) {
            this.finalPayload.variants[index] = payload;
        } else if (
            this.finalPayload.hasOwnProperty('variants') &&
            index === undefined
        ) {
            this.finalPayload.variants.push(payload);
        } else {
            console.log('update set item payload entered in else block');
        }
    }

    updateFinalPayload(payload) {
        this.finalPayload = payload;
    }

    getFinalPayload() {
        return this.finalPayload;
    }

    setAdditionalField(SchemaPropertyAttribute) {
        this.schemaPropertyAttribute = SchemaPropertyAttribute;
    }

    getSchemaAttrProperty() {
        return this.schemaPropertyAttribute;
    }

    setPrimaryColor(colorAttr) {
        this.colorAtt = colorAttr;
        this.primaryColorAdded$.next();
    }

    setFootwearSize(sizeArray) {
        this.footwearSize$.next(sizeArray);
    }

    primaryColorSet() {
        return this.primaryColorAdded$;
    }

    getPrimaryColor() {
        return this.colorAtt;
    }

    private sizes = {
        'Size Option 1': [
            'XXXXX-Small',
            'XXXX-Small',
            'XXX-Small',
            'XX-Small',
            'X-Small',
            'Small',
            'Medium',
            'Large',
            'X-Large',
            'XX-Large',
            'XXX-Large',
            'XXXX-Large',
            'XXXXX-Large',
        ],
        'For Adults ( Size in Inches)': [
            // 'Size Option 2' : [
            '20',
            '22',
            '24',
            '26',
            '28',
            '30',
            '32',
            '34',
            '36',
            '38',
            '40',
            '42',
            '44',
            '46',
            '48',
            '50',
            '52',
            '54',
            '56',
            '58',
            '60',
        ],
        'For Kids( Select the age)': [
            // 'Size Option 3' : [
            '0',
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '10',
            '11',
            '12',
            '13',
            '14',
            '15',
            '16',
        ],
        'Size Option 4': ['Free Size'],
    };

    private footwearSizes = {
        'Mens Footwear size': [
            '4 UK (38 EU)',
            '5 UK (39 EU)',
            '6 UK (40 EU)',
            '7 UK (41 EU)',
            '8 UK (42 EU)',
            '9 UK (43 EU)',
            '10 UK (44 EU)',
            '11 UK (45 EU)',
            '12 UK (46 EU)',
            '13 UK (47 EU)',
            '14 UK (48 EU)',
        ],
        'Womens Footwear size': [
            '2 UK (35 EU)',
            '3 UK (36 EU)',
            '4 UK (37 EU)',
            '5 UK (38 EU)',
            '6 UK (39 EU)',
            '7 UK (40 EU)',
            '8 UK (41 EU)',
            '9 UK (42 EU)',
            '10 UK (43 EU)',
            '11 UK (44 EU)',
            '12 UK (45 EU)',
        ],
        'Boys Footwear size': [
            '1 UK (18 EU)',
            '1.5 UK (35 EU)',
            '2 UK (19 EU)',
            '2.5 UK (36 EU)',
            '3 UK (20 EU)',
            '3.5 UK (37 EU)',
            '4 UK (22 EU)',
            '4.5 UK (38 EU)',
            '5 UK (23 EU)',
            '5.5 UK (39 EU)',
            '6 UK (24 EU)',
            '7 UK (25 EU)',
            '8 UK (26 EU)',
            '9 UK (27 EU)',
            '10 UK (28 EU)',
            '11 UK (29 EU)',
            '12 UK (31 EU)',
            '13 UK (33 EU)',
            '3 US (32-33 EU)',
            '4 US (33-34 EU)',
            '5 US (34-35 EU)',
            '6 US (36-37 EU)',
            '7 US (37-38 EU)',
            '8 US (38-39 EU)',
            '9 US (39-40 EU)',
            '10 US (41-42 EU)',
            '11 US (42-43 EU)',
            '12 US (43-44 EU)',
            '4.5 UK (21.5 EU)',
            '5.5 UK (22.5 EU)',
            '6.5 UK (23.5 EU)',
            '7.5 UK (24.5 EU)',
            '8.5 UK (26 EU)',
            '9.5 UK (27.5 EU)',
            '11.5 UK (30 EU)',
            '12.5 UK (31.5 EU)',
            '13.5 (32.5 EU)',
        ],
        'Girls Footwear size': [
            '1 UK (18 EU)',
            '2 UK (19 EU)',
            '3 UK (20 EU)',
            '4 UK (22 EU)',
            '5 UK (23 EU)',
            '6 UK (24 EU)',
            '7 UK (25 EU)',
            '8 UK (26 EU)',
            '9 UK (27 EU)',
            '10 UK (28 EU)',
            '11 UK (29 EU)',
            '12 UK (31 EU)',
            '13 UK (33 EU)',
            '3 US (32-33 EU)',
            '4 US (33-34 EU)',
            '5 US (34-35 EU)',
            '6 US (36-37 EU)',
            '7 US (37-38 EU)',
            '8 US (38-39 EU)',
            '9 US (39-40 EU)',
            '10 US (41-42 EU)',
            '11 US (42-43 EU)',
            '12 US (43-44 EU)',
            '4.5 UK (21.5 EU)',
            '5.5 UK (22.5 EU)',
            '6.5 UK (23.5 EU)',
            '7.5 UK (24.5 EU)',
            '8.5 UK (26 EU)',
            '9.5 UK (27.5 EU)',
            '11.5 UK (30 EU)',
            '12.5 UK (31.5 EU)',
            '13.5 (32.5 EU)',
        ],
    };

    getSizes() {
        return this.sizes;
    }

    getFootwearSizes() {
        return this.footwearSizes;
    }

    uploadToMediaStore(requesBody) {
        return this.httpClient.post(
            environment.with_auth_url + '/media-store/files',
            requesBody
        );
    }

    uploadImage(
        requestBody: FormData
    ): Observable<IImageUploadSuccessResponse<IImageUploadSuccess>> {
        return this.httpClient.post<
            IImageUploadSuccessResponse<IImageUploadSuccess>
        >(environment.with_auth_url + '/seller/catalog-upload', requestBody);
    }

    uploadImageWithProgress(requestBody: FormData): Observable<HttpEvent<any>> {
        return this.httpClient.post(
            environment.with_auth_url + '/seller/catalog-upload',
            requestBody,
            {
                reportProgress: true,
                observe: 'events',
            }
        );
    }

    getFromMediaStore(imageKey) {
        const url =
            environment.without_auth_url + '/cmedia-store/files/' + imageKey;
        return url;
    }


    clearProperties() {
        this.setItems = [];
    }

    fetchCategorySchema(
        categoryId = '16abecae-91a8-4096-821f-e77d3703a020',
        type
    ) {
        // let params = new HttpParams();
        // params = params.append('isSetProduct', 'true');
        // commenting as this param is not needed.
        const url =
            environment.with_auth_url +
            '/product-catalog/api/v1/schema/' +
            categoryId +
            '?productType=' +
            type;
        return this.httpClient.get(url);
        // return this.httpClient.get(url ,{ params });
    }
    fetchBrandDetail() {
        const leafNodeId =
            this.addProductService.fetchLeafCategoryNumericID() ||
            this.getNumericId();
        const url =
            environment.with_auth_url +
            '/seller/api/v1/product/approvedBrands?leafNodeId=' +
            leafNodeId;
        return this.httpClient.get(url);
    }

    setBrandDetail(brandList) {
        this.brandDetail$.next(brandList);
    }

    getBrandDetail() {
        return this.brandDetail$;
    }

    fetchProductAttributes(
        categoryId = '16abecae-91a8-4096-821f-e77d3703a020'
    ) {
        const serviceUrl =
            '/productcategory/api/v1/attributes?page=1&perPage=100&sortBy=id&categoryId=';
        let prodAttrUrl = environment.with_auth_url + serviceUrl + categoryId;
        return this.httpClient.get(prodAttrUrl);
    }

    fetchVariationThemes(id) {
        this.variationThemeId = id;
        const serviceUrl =
            '/productcategory/api/v1/attributes?page=1&perPage=100&sortBy=id&variationThemeId=';
        const themeUrl = environment.with_auth_url + serviceUrl + id;
        return this.httpClient.get(themeUrl);
    }

    fetchSetThemes(id = this.setThemeId) {
        this.setThemeId = id;
        const serviceUrl =
            '/productcategory/api/v1/attributes?page=1&perPage=100&sortBy=id&setThemeId=';
        const themeUrl = environment.with_auth_url + serviceUrl + id;
        return this.httpClient.get(themeUrl);
    }

    resetAllValues() {
        this.setItems = [];
        this.finalPayload = {};
        this.variantItemIndex = undefined;
        this.editFlowState = false;
        this.variantAttributesMaster = undefined;
        this.productAttributesMaster = undefined;
        this.schemaPropertyAttribute = undefined;
        this.productDetailsSaved = undefined;
    }

    setVariationThemeIds({ variationThemeId, setThemeId }) {
        this.variationThemeId = variationThemeId;
        this.setThemeId = setThemeId;
    }

    saveProductAsDraft() {
        const payload = this.draftPayload();
        if(this.addProductService.isRetentionCategory) {
            const variationThemeKnot ="setName"
            const leafNodeId = this.addProductService.fetchLeafCategoryNumericID() || this.addProductService.getleafNumericId() || this.getNumericId() || localStorage.getItem('leafNodeId');
            payload["variationThemeKnot"] = variationThemeKnot
            payload["leafNodeId"] = leafNodeId
            delete payload["variantAttributes"]
            delete payload["variationThemeId"]
            payload.variants?.forEach(variant=>{
              delete variant['color']
              delete variant['size']
              variant["variationThemeKnot"] = variationThemeKnot
              variant["leafNodeId"] = leafNodeId
            })
        }
        return this.httpClient.post(
            environment.with_auth_url +
                '/product-catalog/api/v3/products/draft',
            payload
        );
    }

    draftPayload() {
        let currentPayload = { ...this.finalPayload };
        let isVariantAlreadyAvailable = true;
        let setItemsLocalList = this.setItems;
        if (!currentPayload.variants) {
            currentPayload['variants'] = [];
            isVariantAlreadyAvailable = false;
        }
        const sellerId = sessionStorage.getItem('orgId'),
            isDefault = false,
            isActive = true,
            isDeleted = false;
        let setItemObj: any = {
            setItems: [...setItemsLocalList],
            ...{ sellerId },
            ...{ isDefault },
            ...{ isActive },
            ...{ isDeleted },
        };
        if (
            setItemsLocalList.length > 0 &&
            setItemsLocalList[0]?.images?.length > 0
        ) {
            setItemObj = {
                ...setItemObj,
                ...{ images: setItemsLocalList[0].images },
            };
        } else if (currentPayload?.images?.length > 0) {
            setItemObj = {
                ...setItemObj,
                ...{ images: currentPayload.images },
            };
        } else {
            setItemObj = { ...setItemObj, ...{ images: [] } };
        }

        if (
            setItemsLocalList?.length > 0 &&
            setItemsLocalList[0]?.primaryImage
        ) {
            setItemObj = {
                ...setItemObj,
                ...{ primaryImage: setItemsLocalList[0].primaryImage },
            };
        } else if (currentPayload?.primaryImage) {
            setItemObj = {
                ...setItemObj,
                ...{ primaryImage: currentPayload.primaryImage },
            };
        } else {
            setItemObj = { ...setItemObj, ...{ primaryImage: '' } };
        }

        if (
            this.finalPayload &&
            this.finalPayload.variants &&
            this.finalPayload.variants.length > 0 &&
            this.finalPayload.variants[0]?.attributes
        ) {
            setItemObj = {
                ...setItemObj,
                ...{ attributes: this.finalPayload.variants[0]?.attributes },
            };
        } else {
            setItemObj = { ...setItemObj, ...{ attributes: {} } };
        }
        if (!isVariantAlreadyAvailable) {
            currentPayload.variants.push(setItemObj);
        }
        if (this.variationThemeId) {
            currentPayload.variationThemeId = this.variationThemeId;
        } else {
            currentPayload.variationThemeId = '';
        }
        currentPayload.schemaName = this.getSchemaName();
        currentPayload.isActive = true;
        currentPayload.isDeleted = false;
        currentPayload.state = 'DRAFTED';
        currentPayload.sellerId = sessionStorage.getItem('orgId');
        // currentPayload.primaryImage = setItemObj.primaryImage || '';
        // currentPayload.images = setItemObj.images;
        isVariantAlreadyAvailable = true;
        if (currentPayload?.productType == 'SET_VARIANT') {
            if (
                this.selectedVaraintsListSizeChart &&
                this.selectedVaraintsListSizeChart?.previewUrl.toString() !== ''
            ) {
                currentPayload.attributes = {
                    ...currentPayload.attributes,
                    sizeChart: this.selectedVaraintsListSizeChart.previewUrl,
                };
            }
        }
        return currentPayload;
    }

    setFromImageTab(flag) {
        this.firstInitCall = flag;
    }

    getFromImageTab() {
        return this.firstInitCall;
    }

    setColorThemes(themes) {
        this.themes = [...themes];
    }

    getColorThemes() {
        return this.themes;
    }

    updateSetThemeData(variantThemeData: ISetThemeData): void {
        this.variantThemeData = variantThemeData;
        this.addittionalFieldsObj = this.getAdditionFormGroupFields();
        console.log('additional field obj', this.addittionalFieldsObj);
    }

    updateSetVariantSetDataFormList(
        variantSetDataFormList,
        variantSetDataFormRequiredList,
        schemaProperties
    ): void {
        this.variantSetDataFormList = variantSetDataFormList;
        this.variantSetDataFormRequiredList = variantSetDataFormRequiredList;
        this.schemaProperties = schemaProperties;
    }

    transformVariantsDataToPayLoadInSetVariants(inputData) {
        const currentPayLoad = { ...this.finalPayload };
        const final = [];
        let attributes = {};
        let themes = [];
        inputData.forEach((data, i) => {
            let setItems: any = [];
            let colorMap = new Map();
            let setName = 'Set of ';
            let qty = data?.variants?.reduce((acc, curr) => {
                acc = acc + Number(curr.quantity);
                return acc;
            }, 0);
            setName += qty + ' (';
            data.variants.forEach((variant) => {
                const color = variant.colorLabel;
                if (!colorMap.has(color)) {
                    colorMap.set(color, []);
                }
                let item = colorMap.get(color);
                item.push(variant);
                colorMap.set(color, item);
                setName +=
                    variant.colorLabel +
                    (this.addProductService.isApparelCategory?' / ':'/') +
                    variant.size +
                    ' - ' +
                    variant.quantity +
                    ', ';
            });
            setName = setName.substring(0, setName.length - 2);
            setName += ')';
            themes.push(`Set of ${qty}`);

            for (const ele of colorMap.values()) {
                console.log('ele', ele);
                let items = ele.map((x) => {
                    return {
                        quantity: x.quantity.toString(),
                        value: x.size,
                        key: this.sizeTheme,
                    };
                });
                setItems.push({
                    value: ele[0].colorLabel,
                    items: items,
                    key: 'color',
                });
            }
            attributes = {
                setName: setName,
            };
            // if footwear category then add footwearSizeType
            if (
                this.addProductService.getCategoryName() == 'FOOTWEAR' ||
                this.getCategoryId() === 'af07e2a8-f218-4697-bb0c-9f240c5bc1d3'
            ) {
                attributes = {
                    ...attributes,
                    // sizeType: this.getCurrentSizeTypeValue() || this.getSizeTypevalue()
                    // footwearSizeType: 'Womens Footwear size',
                };
            }
            let productDimension;
            let productUnit;
            let length;
            let lengthUnit;
            for (const key in data?.setDetailsData?.setDetailsForm?.value) {
                if (key !== 'skuId' && key !== 'productDimension' && key !=='productDimensionUOM' && key !=='lengthUOM') {
                    if (data?.setDetailsData?.setDetailsForm?.value[key]) {
                        if (
                            key == 'mrp' ||
                            key == 'moq' ||
                            key == 'sellingPrice'
                        ) {
                            attributes[key] =
                                +data?.setDetailsData?.setDetailsForm?.value[
                                    key
                                ];
                        } else {
                            attributes[key] =
                                data?.setDetailsData?.setDetailsForm?.value[
                                    key
                                ];
                        }
                    }
                }
                else if (key === 'productDimension'  && data?.setDetailsData?.setDetailsForm?.value[key]) {
                  productDimension = data?.setDetailsData?.setDetailsForm?.value[key];}
                else if (key === 'productDimensionUOM' && data?.setDetailsData?.setDetailsForm?.value[key]) {
                  productUnit = data?.setDetailsData?.setDetailsForm?.value[key];
                }
                else if (key === 'lengthUOM' && data?.setDetailsData?.setDetailsForm?.value[key]) {
                  lengthUnit = data?.setDetailsData?.setDetailsForm?.value[key];
                }
            }
            if (productDimension && productUnit) {
              attributes['productDimension'] = productDimension + " " + productUnit;
              attributes['productDimensionUOM'] = productUnit;
          }
          if (lengthUnit) {
            attributes['length'] = attributes['length'] + " " + lengthUnit;
            attributes['lengthUOM'] = lengthUnit;
          }

            let extraKeys = ['isEditMode', 'isValid'];
            extraKeys.forEach((key) => {
                delete attributes[key];
            });
            const leafNodeId =
            this.addProductService.fetchLeafCategoryNumericID() || this.addProductService.getleafNumericId() || this.getNumericId() || localStorage.getItem('leafNodeId');;
            let obj = {
                isDefault: false,
                sellerId: sessionStorage.getItem('orgId'),
                isDeleted: false,
                setItems: setItems,
                isActive: true,
                skuId: data?.setDetailsData?.setDetailsForm?.value?.skuId,
                attributes: attributes,
                campaignAssociated: false,
                variationThemeKnot:
                    (this.addProductService.getCategoryName() == 'FOOTWEAR' || this.addProductService.isApparelCategory) &&
                    this.getVariationThemeKnot()
                        ? this.getVariationThemeKnot()
                        : 'setName',
                leafNodeId:
                    (this.addProductService.getCategoryName() == 'FOOTWEAR' || this.addProductService.isApparelCategory || this.addProductService.isRetentionCategory)
                        ? leafNodeId
                        : '',
            };
            obj['id'] = data.variantId ? data?.variantId : '';
            final.push(obj);
        });
        this.setColorThemes(themes);
        return final;
    }

    addVariantImagestoPayLoad(finalPayload: any): any {
        this.selectedVaraintsList.forEach((item, i) => {
            if (item.variantImages.length) {
                // if (i == 0) {
                //     finalPayload['primaryImage'] =
                //         item?.variantImages[0]?.previewUrl;
                //     finalPayload.images = [...item?.variantImages]
                //         .map((el) => el.previewUrl)
                //         .slice(1);
                // }
                finalPayload.variants[i]['primaryImage'] =
                    item?.variantImages[0]?.previewUrl;
                finalPayload.variants[i].images = item?.variantImages
                    .map((el) => el.previewUrl)
                    .slice(1);

                // finalPayload['primaryImage'] =
                // item?.variantImages[0]?.previewUrl;

                // finalPayload.images = item?.variantImages
                //     .map((el) => el.previewUrl)
                //     .slice(1);
            }
        });
        return finalPayload;
    }

    sortVariantsByAlpaheticalOrder(
        variants: Array<IVariantGridData>
    ): Array<IVariantGridData> {
        const isApparelCategory = this.addProductService.isApparelCategory
        const availableSizes = this.addProductService.availableSizes
        variants.sort((a, b) => {
          if (a.colorLabel === b.colorLabel)
            if(isApparelCategory) {
                return this.compareApparelSizes(a.size,b.size,availableSizes)
            } else {
                return this.compareAlphanumeric(a.size, b.size);
            }
          else return this.compareAlphanumeric(a.colorLabel, b.colorLabel);
        });
        return variants;
    }

    compareApparelSizes(a,b,sizeArray) {
      return sizeArray?.indexOf(a) - sizeArray?.indexOf(b)
    }

    //Create dynamic form for set variant

    createSetDetailsFormGroup(
        variantId: string = '',
        setProductDetail: any = {}
    ): FormGroup {
        //const addittionalFieldsObj = this.getAdditionFormGroupFields();
        const formGroupConfig = {};
        const skuId: string = variantId
            ? setProductDetail.variants[variantId].skuId
            : '';
        if(this.isFootwearCat || this.addProductService.isApparelCategory) {
            formGroupConfig['skuId'] = new FormControl(skuId, [
                Validators.required,
                Validators.minLength(1),
                Validators.maxLength(40)
            ]);
        } else {
            formGroupConfig['skuId'] = new FormControl(skuId, [
                Validators.required,
                Validators.maxLength(40),
                Validators.pattern('^[- _:.,\\\\d /()0-9A-Za-z]*$'),
            ]);
        }
        const moq: any = variantId
            ? setProductDetail.variants[variantId].attributes.find(
                  (obj: any) => obj.key === 'moq'
              )
            : '';
        formGroupConfig['moq'] = new FormControl(moq?.value, [
            Validators.required,
            Validators.min(1),
            Validators.maxLength(5),
        ]);
        const mrp: any = variantId
            ? setProductDetail.variants[variantId].attributes.find(
                  (obj: any) => obj.key === 'mrp'
              )
            : '';
        formGroupConfig['mrp'] = new FormControl(mrp?.value, [
            Validators.required,
            Validators.min(1),
            Validators.maxLength(10),
            //Validators.pattern('^(?:d*.d{1,2}|d+)$'),
        ]);
        const sellingPrice: any = variantId
            ? setProductDetail.variants[variantId].attributes.find(
                  (obj: any) => obj.key === 'sellingPrice'
              )
            : '';
        formGroupConfig['sellingPrice'] = new FormControl(sellingPrice?.value, [
            Validators.required,
            Validators.min(1),
            Validators.maxLength(10),
            //Validators.pattern('^(?:d*.d{1,2}|d+)$'),
        ]);
        const eanNumber: any = variantId
            ? setProductDetail.variants[variantId].attributes.find(
                  (obj: any) => obj.key === 'eanNumber'
              )
            : '';
        if (!this.isFootwearCat && !this.addProductService.isApparelCategory) {
            formGroupConfig['eanNumber'] = new FormControl(eanNumber?.value, [
                Validators.maxLength(13),
                Validators.minLength(1),
                Validators.pattern('^[0-9]*$'),
            ]);
        }else if(this.addProductService.isApparelCategory){
          formGroupConfig['eanNumber'] = new FormControl(eanNumber?.value, [
            Validators.maxLength(16),
            Validators.minLength(13),
            Validators.pattern('^[0-9A-Za-z ]*$'),
        ]);
        }
         else {
            formGroupConfig['eanNumber'] = new FormControl(eanNumber?.value, [
                Validators.maxLength(16),
                Validators.minLength(13),
                Validators.pattern('^[0-9A-Za-z]*$'),
            ]);
        }
        Object.keys(this.addittionalFieldsObj).forEach((field: string) => {
            let fieldValidators: ValidatorFn[] = [];
            if (this.addittionalFieldsObj[field].hasOwnProperty('required'))
                fieldValidators.push(Validators.required);
            if (this.addittionalFieldsObj[field].hasOwnProperty('minLength'))
                fieldValidators.push(
                    Validators.minLength(
                        this.addittionalFieldsObj[field]['minLength']
                    )
                );
            if (this.addittionalFieldsObj[field].hasOwnProperty('maxLength'))
                fieldValidators.push(
                    Validators.maxLength(
                        this.addittionalFieldsObj[field]['maxLength']
                    )
                );
            if (this.addittionalFieldsObj[field].hasOwnProperty('pattern'))
                fieldValidators.push(
                    Validators.pattern(
                        this.addittionalFieldsObj[field]['pattern']
                    )
                );
            const fieldObject = variantId
                ? setProductDetail.variants[variantId].attributes.find(
                      (obj: any) => obj.key === field
                  )
                : '';
            if (field == 'ageGroup' || field == 'ageSize') {
                const ageGroupValue = fieldObject?.value?.slice(1, -1).split(', ').map((item) => item)
                if(ageGroupValue?.length >1 || ageGroupValue?.[0]) {
                    formGroupConfig[field] = new FormControl(
                        ageGroupValue,fieldValidators);

                } else {
                    formGroupConfig[field] = new FormControl(
                        null, fieldValidators);
                }
            }
            else if(field == 'productDimension') {
                const value = fieldObject?.value?.split(' ')?.[0]
                if(value) {
                    formGroupConfig[field] = new FormControl(value)
                } else {
                    formGroupConfig[field] = new FormControl(null,fieldValidators)
                }
            } else if(field == 'length' && this.addittionalFieldsObj.hasOwnProperty('lengthUOM')) {
                const value = fieldObject?.value?.split(' ')?.[0]
                if(value) {
                    formGroupConfig[field] = new FormControl(value)
                } else {
                    formGroupConfig[field] = new FormControl(null, fieldValidators)
                }
            }
            else {
                formGroupConfig[field] = new FormControl(
                    fieldObject?.value,
                    fieldValidators
                );
            }
        });
        const setVariantDetailsForm = new FormGroup(formGroupConfig, {
            validators: [this.sellingPriceMRPValidator()],
        });
        console.log("setVariantDetailsForm",setVariantDetailsForm)
        return setVariantDetailsForm;
    }

    private getAdditionFormGroupFields(): any {
        const addittionalFieldsObj = Object.assign(
            {},
            this.variantSetDataFormList
        );
        const addittionalFieldsReqList: string[] =
            this.variantSetDataFormRequiredList;
        const addittionalFieldsObjKeys: string[] =
            Object.keys(addittionalFieldsObj);
        const variantMandatoryFields: string[] =
            this.VARIANT_MANDATORY_FIELDS.map((field: string) =>
                field.split('_').join('')
            );
        const nonProperties: string[] = this.NON_PROPERTIES.map(
            (property: string) => property.split('_').join('')
        );
        const variantThemeKeys: string[] = this.variantThemeData.content.map(
            (themeVariant: ISetThemeVariant) => themeVariant.key
        );
        addittionalFieldsObjKeys.forEach((objKey: string) => {
            if (variantMandatoryFields.indexOf(objKey.toUpperCase()) !== -1) {
                //exclude duplicate fields
                delete addittionalFieldsObj[objKey];
            }
            if (nonProperties.indexOf(objKey.toUpperCase()) !== -1) {
                //exclude non property fields
                delete addittionalFieldsObj[objKey];
            }
            variantThemeKeys.forEach((variantThemeKey: string) => {
                if (
                    objKey
                        .toLowerCase()
                        .indexOf(variantThemeKey.toLowerCase()) !== -1
                ) {
                    //exclude theme keys
                    delete addittionalFieldsObj[objKey];
                }
            });
        });
        Object.keys(addittionalFieldsObj).forEach((field: string) => {
            if (addittionalFieldsReqList.indexOf(field) !== -1) {
                addittionalFieldsObj[field].required = true;
            }
        });
        return addittionalFieldsObj;
    }

    private sellingPriceMRPValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors => {
            const mrpControl = control.get('mrp');
            const sellingPriceControl = control.get('sellingPrice');

            if (
                mrpControl &&
                sellingPriceControl &&
                mrpControl.value !== null &&
                sellingPriceControl.value !== null
            ) {
                const mrp = +mrpControl.value;
                const sellingPrice = +sellingPriceControl.value;
                if (sellingPrice > mrp) {
                    sellingPriceControl.setErrors({
                        sellingPriceGreaterThanMRP: true,
                    });
                    return { sellingPriceGreaterThanMRP: true };
                }
            }
            // If both controls have not been touched yet, return null
            if (mrpControl.pristine || sellingPriceControl.pristine) {
                return null;
            }
        };
    }
    checkDuplicateSkuIdError(
        variantIndex: number,
        selectedVaraintsList: Array<ISelectedVariants>
    ): ValidatorFn {
        return (control: AbstractControl): ValidationErrors => {
            const skuId: string = control.value;
            const skuIdsList = selectedVaraintsList
                .filter(
                    (selectedVaraints: ISelectedVariants, index) =>
                        variantIndex !== index
                )
                .map((selectedVaraints: ISelectedVariants) =>
                    selectedVaraints.setDetailsData.setDetailsForm
                        .get('skuId')
                        ?.value?.trim()
                        ? selectedVaraints.setDetailsData.setDetailsForm.get(
                              'skuId'
                          ).value
                        : null
                )
                .filter((skuId) => skuId !== null);
            const duplicates = skuIdsList.filter((id: string) => id === skuId);

            if (duplicates.length) {
                return { duplicateError: true }; // Return custom error if validation fails
            }
            return null; // Return null if validation passes
        };
    }

    checkDuplicateSetVariants(
        newVariants: ISelectedVariants,
        variantModalData: IVariantModelData = { mode: '', index: 0 }
    ): boolean {
        let themes: Array<string> = [];
        this.selectedVaraintsList.forEach(
            (selectedVariants: ISelectedVariants, i) => {
                if (variantModalData.mode && variantModalData.index === i) {
                    return;
                }
                let setName = 'Set of ';
                let qty = selectedVariants?.variants?.reduce((acc, curr) => {
                    acc = acc + Number(curr.quantity);
                    return acc;
                }, 0);
                setName += qty + ' (';
                selectedVariants.variants.forEach((variant) => {
                    setName +=
                        variant.colorLabel +
                        '/' +
                        variant.size +
                        ' - ' +
                        variant.quantity +
                        ', ';
                });
                setName = setName.substring(0, setName.length - 2);
                setName += ')';
                themes.push(setName);
            }
        );
        console.log('themes', themes);
        //New variant theme block
        let newSetName = 'Set of ';
        let newSetqty = newVariants?.variants?.reduce((acc, curr) => {
            acc = acc + Number(curr.quantity);
            return acc;
        }, 0);
        newSetName += newSetqty + ' (';
        newVariants.variants.forEach((variant) => {
            newSetName +=
                variant.colorLabel +
                '/' +
                variant.size +
                ' - ' +
                variant.quantity +
                ', ';
        });
        newSetName = newSetName.substring(0, newSetName.length - 2);
        newSetName += ')';
        console.log('newSetName', newSetName);
        //Comapare new variant against each variant
        return themes.includes(newSetName);
    }

    transformSetName(name) {
        let regex = new RegExp('Set of [0-9]+');
        let result = regex.exec(name);
        return result[0];
    }
    emitVariantInfoAttr(message: any) {
        this.messageSource.next(message);
    }

    setColorObj(colorCode: ColorObj[]) {
        this.colorCode = colorCode;
    }

    getColorObj() {
        return this.colorCode;
    }

    getColorMapper() {
        const mapper = {};
        this.colorCode?.forEach((code) => {
            mapper[code.displayName] = code.colorCode;
        });
        return mapper;
    }

    setSizeObj(size) {
        this.footwearSize = size;
    }

    setApparelSizeObj(size) {
        this.apparelSize = size;
    }

    getApparelSize() {
        return this.apparelSize
    }

    getFootwearSizeObj() {
        return this.footwearSize;
    }

    setproductAttributesFromSchema(productsList) {
        this.productAttributesSchema = productsList;
    }

    getProductAttributesFromSchema() {
        return this.productAttributesSchema;
    }

    setAdditionalPropertiesDetails(list) {
        this.additionalPropertiesDetails = list;
    }

    setAdditionalDetail(list) {
        this.additionalDetails = list;
    }

    getAdditionalDetail() {
        return this.additionalDetails;
    }

    getAdditionalPropertiesDetails() {
        return this.additionalPropertiesDetails;
    }

    updateSetThemeFootwearData(data: any): void {
        this.FootwearvariantThemeData = data;
        this.addittionalFieldsObj =
            this.getAdditionFormGroupFieldsForFootwear();
    }
    private getAdditionFormGroupFieldsForFootwear(): any {
        const addittionalFieldsObj = Object.assign(
            {},
            this.variantSetDataFormList
        );
        const addittionalFieldsReqList: string[] =
            this.variantSetDataFormRequiredList;
        const addittionalFieldsObjKeys: string[] =
            Object.keys(addittionalFieldsObj);
        const variantMandatoryFields: string[] =
            this.VARIANT_MANDATORY_FIELDS.map((field: string) =>
                field.split('_').join('')
            );
        const nonProperties: string[] = this.NON_PROPERTIES.map(
            (property: string) => property.split('_').join('')
        );
        addittionalFieldsObjKeys.forEach((objKey: string) => {
            if (variantMandatoryFields.indexOf(objKey.toUpperCase()) !== -1) {
                //exclude duplicate fields
                delete addittionalFieldsObj[objKey];
            }
            if (nonProperties.indexOf(objKey.toUpperCase()) !== -1) {
                //exclude non property fields
                delete addittionalFieldsObj[objKey];
            }
            if(objKey != 'ageSize') {
                this.FootwearvariantThemeData?.forEach(
                    (variantThemeKey: string) => {
                        if (
                            objKey
                                .toLowerCase()
                                .indexOf(variantThemeKey.toLowerCase()) !== -1
                        ) {
                            //exclude theme keys
                            delete addittionalFieldsObj[objKey];
                        }
                    }
                );
            }
        });
        Object.keys(addittionalFieldsObj).forEach((field: string) => {
            if (addittionalFieldsReqList.indexOf(field) !== -1) {
                addittionalFieldsObj[field].required = true;
            }
        });
        return addittionalFieldsObj;
    }
    setVariationThemeKnot(themeknot) {
        this.themeKnot = themeknot;
    }
    getVariationThemeKnot() {
        return this.themeKnot;
    }
    close(): void {
        this.dialogRef.close();
    }
    setCurrentSizeTypeValue(currentSizeType) {
        this.currentSizeType = currentSizeType;
    }
    getCurrentSizeTypeValue() {
        return this.currentSizeType;
    }
    resetCurrentSizeType() {
        return (this.currentSizeType = '');
    }

    setSizeType(sizeType: string) {
        this.currentSizeType = this.getCurrentSizeTypeValue();
        if (this.currentSizeType && this.currentSizeType !== sizeType) {
            const deleteVariantdialogRef = this.dialog.open(
                DeleteSetVariantNewDialogComponent,
                {
                    data: {},
                    // width: '35%',
                    width: '400px',
                    height: '224px',
                    panelClass: 'delete-dialog',
                    // panelClass: 'variant-dialog-container',
                }
            );
            deleteVariantdialogRef.afterClosed().subscribe((confirmed) => {
                if (confirmed) {
                    this.clearVariants();
                    this.currentSizeType = sizeType;
                    this.sizeTypeChangeSubject.next(true); // Emit true when confirmed
                } else {
                    this.sizeTypeChangeSubject.next(false); // Emit false when cancelled
                }
            });
        } else {
            this.currentSizeType = sizeType;
        }
    }
    clearVariants() {
        const finalPayload = this.getFinalPayload();
        this.selectedVaraintsList = [];
        if (finalPayload.variants) {
            finalPayload.variants = [];
        }
        this.eventBroker.publish(
            new SetSelectedTabEventBroker('deletedSetVariant')
        );
    }
    private compareAlphanumeric(a: string, b: string): number {
        const numRegex = /\d+/;

        // Extract numeric parts
        const aNum = parseInt(a.match(numRegex)?.[0] || '0', 10);
        const bNum = parseInt(b.match(numRegex)?.[0] || '0', 10);

        if (!isNaN(+a) && !isNaN(+b)) {
            return +a - +b; // Numeric comparison
        }

        // If one of them is a number, prioritize it
        if (!isNaN(+a) || !isNaN(+b)) {
            return !isNaN(+a) ? -1 : 1; // Numbers go before strings
        }

        if (aNum !== bNum) {
            return aNum - bNum; // Numerical comparison
        }

        // Both are strings, compare them alphabetically
        return a.localeCompare(b);
    }
    setNumericId(id) {
        this.numericId = id;
    }

    getNumericId() {
        return this.numericId;
    }

    setCategoryId(id) {
        this.categoryId = id;
    }

    getCategoryId() {
        return this.categoryId;
    }
    setSizeTypevalue(value) {
        this.sizeTypeValue = value;
    }
    getSizeTypevalue() {
        return this.sizeTypeValue;
    }

    setCategoryType(isFootwearType) {
        this.isFootwearCat = isFootwearType;
    }
}
